import { useContext, Context } from 'react'; // eslint-disable-line
import _noop from 'lodash/noop';

export const emptyModalProviderValue: ModalProviderValue = {
    add: (): string => '',
    hasOpenModalRef: {
        current: false,
    },
    remove: _noop,
};

// This hook should be extended on an app-by-app basis because the context passed to useContext() is
// expected to be a singleton. See packages/web/src/hooks/useModal.ts for an example.
export const useModalBase = (
    modalContext: Context<ModalProviderValue>,
): ModalProviderValue => {
    if (modalContext === null || modalContext === undefined) {
        return emptyModalProviderValue;
    }

    return useContext(modalContext);
};
